import React from 'react';
import styled from 'styled-components';
import Icon from '../../../../components/Icon';
import Button from '../../../../components/Button';
import { Link } from 'react-router-dom';
import { I18n } from 'react-redux-i18n';

const AllNotationCMSContainer = styled.div`
  display: ${(props) => (props.hide ? 'hidden' : 'flex')};
  flex-direction: row;
  align-items: center;
  gap: 30px;
  margin-bottom: 20px;

  @media (max-width: 1200px) {
    border: 2px solid hsl(0, 0%, 80%);
    border-radius: 4px;
    padding: 20px;
    gap: 10px;
    align-items: start;
    flex-direction: column;
    justify-content: center;
  }

  @media (max-width: 845px) {
    padding: 16px;
  }

  .titleContainer {
    @media (max-width: 845px) {
      display: flex;
      gap: 6px;
    }
  }

  .title {
    font-family: ${(props) => props.theme.fonts.oswald};
    font-size: 20px;
    color: #172c39;
    text-transform: uppercase;
    white-space: nowrap;
    line-height: 24px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      flex-direction: column;
      justify-content: center;
      text-align: center;
      font-size: 16px;
    }
  }

  .titleRed {
    color: ${(props) => props.theme.colors['terra-cotta']};

    @media (max-width: 845px) {
      color: #172c39;
    }
  }

  .separator {
    height: 60px;
    width: 2px;
    background-color: #adb5bd;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '1200px'}) {
      display: none;
    }
  }

  p {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    color: #2b3d54;
    font-size: 14px;
    text-align: justify;
    line-height: 1.8;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
    }
  }

  span {
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
  }

  .tmpLogoContainer {
    font-size: 100px;
  }

  .buttonGoJournals {
    width: 261px;

    @media (max-width: ${(props) =>
        props.theme.devices.isTablet ? '0px' : '845px'}) {
      width: calc(100vw - 68px);
      margin-left: 0;
    }
  }

  a {
    text-decoration: none;
  }
`;

const AllNotationCMS = ({ admin }) => (
  <AllNotationCMSContainer>
    <div className="tmpLogoContainer">
      <Icon icon="logo-medium" />
    </div>
    <div className="titleContainer">
      <h1 className="title">{I18n.t('notes.allNotes.cms.titleLine1')}</h1>
      <h1 className="title titleRed">
        {I18n.t('notes.allNotes.cms.titleLine2')}
      </h1>
    </div>
    <div className="separator" />
    <p className="message">
      <p>{I18n.t('notes.allNotes.cms.heavyText')},</p>
      <p>{I18n.t('notes.allNotes.cms.text')}</p>
    </p>
    {admin && (
      <Link to="/user-space/subscriptions">
        <Button
          className="buttonGoJournals"
          label={I18n.t('notes.allNotes.cms.subscriptionButtonLabel')}
          textTransform="normal"
        />
      </Link>
    )}
  </AllNotationCMSContainer>
);

export default AllNotationCMS;
